<template>
    <div>
        <div class="d-none d-lg-block" role="tablist">
            <div v-b-toggle.experience class="toggle-filter">
                <b>{{ $t('Livello di esperienza') }}</b>
                <i class="fa fa-caret-up when-opened text-grey"></i>
                <i class="fa fa-caret-down when-closed text-grey"></i>
                <hr class="mb-1 mt-1" />
            </div>
            <b-collapse id="experience" class="pt-2" visible accordion="experience" role="tabpanel">
                <b-form-group>
                    <b-form-checkbox-group plain stacked v-model="filters.profile_rank">
                        <b-form-checkbox value="top"><img src="~/assets/images/badge-gold@2x.svg" class="badge-small ml-1 mr-1" /> {{ $t('Top Senior') }}</b-form-checkbox>
                        <b-form-checkbox value="senior"><img src="~/assets/images/badge-silver@2x.svg" class="badge-small ml-1 mr-1" /> {{ $t('Senior') }}</b-form-checkbox>
                        <b-form-checkbox value="junior"><img src="~/assets/images/badge-bronze@2x.svg" class="badge-small ml-1 mr-1" /> {{ $t('Junior') }}</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-collapse>

            <div v-if="$auth.loggedIn && $auth.user.is_admin">
                <div v-b-toggle.status class="toggle-filter">
                    <b>{{ $t('Stato') }}</b>
                    <i class="fa fa-caret-up when-opened text-grey"></i>
                    <i class="fa fa-caret-down when-closed text-grey"></i>
                    <hr class="mb-1 mt-1" />
                </div>
                <b-collapse id="status" class="pt-2" visible accordion="status" role="tabpanel">
                    <b-form-group>
                        <b-form-checkbox-group plain stacked v-model="filters.status">
                            <b-form-checkbox value="published">{{ $t('Verificato') }}</b-form-checkbox>
                            <b-form-checkbox value="pending">{{ $t('Da verificare') }}</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                </b-collapse>
            </div>
        </div>
        <div class="d-block d-lg-none">
            <div class="d-flex align-items-center p-0 pl-2 background-white" style="min-height: inherit;">
                <div class="no-wrap mr-2">
                    <i class="fa fa-sliders"></i> {{ $t('Filtri') }}
                </div>
                <div class="d-flex p-1" style="max-width: 100%; overflow-x: auto">

                    <b-dropdown no-caret variant="link" class="ml-2 position-static d-none d-lg-block">
                        <template slot="button-content">
                            <a class="btn btn-questionnaire btn-filter d-flex align-items-center justify-content-center" :class="{active: filters.order}">
                                <span class="button-title">{{ getLabelFromValue('order') }}</span>
                                <i class="fa fa-caret-down absolute" style="right: 12px"></i>
                            </a>
                        </template>
                        <b-dropdown-item v-for="option in orderOptions" @click.prevent="setFilter('order', option.value)" :key="option.value">{{ option.label }}</b-dropdown-item>
                    </b-dropdown>
                    <div class="ml-2 dropdown d-block d-lg-none align-self-center">
                        <dropup-menu ref="orderFilter" :hide-bottom-bar="true" :show-overlay="true">
                            <template slot="menu-icon">
                                <a class="btn btn-questionnaire btn-filter" :class="{active: filters.order }"> {{ getLabelFromValue('order') }} <i class="fa fa-caret-down ml-2" style="right: 12px"></i></a>
                            </template>
                            <template slot="menu-options">
                                <ul class="filter-options">
                                    <li class="pl-3 p-2">{{ $t('Ordine')}}</li>
                                    <li v-for="option in orderOptions" @click.prevent="filters.order = option.value" :key="option.value" class="d-flex justify-content-between align-items-center font-weight-normal show-icon" style="border-bottom: 1px solid #f4f3f2">
                                        {{ option.label }}
                                        <i class="fa fa-circle fa-lg text-primary" v-if="option.value === filters.order"></i>
                                        <i class="fa fa-circle-o fa-lg text-grey" v-else></i>
                                    </li>
                                </ul>
                            </template>
                        </dropup-menu>
                    </div>

                    <b-dropdown no-caret variant="link" class="ml-2 position-static d-none d-lg-block">
                        <template slot="button-content">
                            <a class="btn btn-questionnaire btn-filter d-flex align-items-center justify-content-center" :class="{active: filters.profile_rank}">
                                <span class="button-title">{{ getLabelFromValue('category') }}</span>
                                <i class="fa fa-caret-down absolute" style="right: 12px"></i>
                            </a>
                        </template>
                        <b-dropdown-item v-for="option in categoryOptions" @click.prevent="setFilter('profile_rank', option.value)" :key="option.value">{{ option.label }}</b-dropdown-item>
                    </b-dropdown>
                    <div class="ml-2 dropdown d-block d-lg-none align-self-center">
                        <dropup-menu ref="categoryFilter" :hide-bottom-bar="true" :show-overlay="true">
                            <template slot="menu-icon">
                                <a class="btn btn-questionnaire btn-filter" :class="{active: filters.profile_rank }"> {{ getLabelFromValue('category') }} <i class="fa fa-caret-down ml-2" style="right: 12px"></i></a>
                            </template>
                            <template slot="menu-options">
                                <ul class="filter-options">
                                    <li class="pl-3 p-2">{{ $t('Categoria')}}</li>
                                    <li v-for="option in categoryOptions" @click.prevent="filters.profile_rank = option.value" :key="option.value" class="d-flex justify-content-between align-items-center font-weight-normal show-icon" style="border-bottom: 1px solid #f4f3f2">
                                        {{ option.label }}
                                        <i class="fa fa-circle fa-lg text-primary" v-if="option.value === filters.profile_rank"></i>
                                        <i class="fa fa-circle-o fa-lg text-grey" v-else></i>
                                    </li>
                                </ul>
                            </template>
                        </dropup-menu>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapFields } from 'vuex-map-fields'
    import DropupMenu from '~/components/DropupMenu'
    import _ from 'lodash'


    export default {

        component: {
            DropupMenu
        },

        props: {
            filters: {
                type: Object,
                default: function () {
                    return {
                        status: 'published',
                        diploma: null,
                        account: 'user',
                        sort: 'created_at',
                        order: 'desc',
                        certified: null,
                        profile_rank: null,
                        invited: false,
                        category: null,
                        questionnaire_completed: null
                    }
                },
            },
        },

        watch: {
            watch: {
                filters: {
                    deep: true,
                    handler: function () {
                        this.$emit('search-accounts');
                    }
                }
            }
        },

        data() {
            return {
                orderOptions: [
                    {value: 'desc', label: 'Più recenti per prime'},
                    {value: 'asc', label: 'Meno recenti per prime'}
                ],
                statusOptions: [
                    {value: null, label: 'Iscrizione'},
                    {value: 'pending', label: 'Richieste iscrizione'},
                    {value: 'published', label: 'Iscritti'}
                ],
                categoryOptions: [
                    {value: null, label: 'Classifica'},
                    {value: 'junior', label: 'Junior'},
                    {value: 'senior', label: 'Senior'},
                    {value: 'top-senior', label: 'Top Senior'}
                ]
            }
        },

        methods: {
            getLabelFromValue (filterName) {

                let optionsName = _.camelCase(filterName);
                let option =  _.find(this[optionsName + 'Options'], { 'value': this.filters[filterName] })
                if (option) return option.label
            }
        },

        mounted () {

        }
    }
</script>

<style lang="scss" scoped>
    .toggle-filter {
        cursor: pointer;
        position: relative;
        > i {
            position: absolute;
            right: 5px;
            top: 5px;
        }
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>